module.exports = __webpack_public_path__ + "img/banner.e5b5a13c.png";